<shared-condition #condition
                  [text]="text"
                  (click)="click()"
                  [optionsFilter]="true"
                  [standaloneCheckbox]="true"
                  ></shared-condition>